import { render, staticRenderFns } from "./requirementModule.vue?vue&type=template&id=88daf8d2&"
import script from "./requirementModule.vue?vue&type=script&lang=ts&"
export * from "./requirementModule.vue?vue&type=script&lang=ts&"
import style0 from "./requirementModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports